export default __webpack_public_path__ + "static/media/977.d8104b1a.png";